import {
  AKA_STUDENT_ABOUT_YOU_STEP,
  AKA_STUDENT_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/AkaProducts/AkaStudent";

import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";

export const mapFromCommerceAkaStudent = (
  data: Record<string, any>,
): FormState => {
  return {
    [AKA_STUDENT_ABOUT_YOU_STEP.id]: {
      country: data.country,
      region: data.region,
    },
    [AKA_STUDENT_PRICE_STEP.id]: {
      coverage: data.coverageGroup,
    },
  };
};
